import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Container from 'common/components/UI/Container';
import Heading from 'common/components/Heading';
import GatsbyImage from 'common/components/GatsbyImage';
import { Icon } from 'react-icons-kit';
import { mail } from 'react-icons-kit/feather/mail';
import { phone } from 'react-icons-kit/feather/phone';

import {
  Section,
  ContentWrapper,
  TextContent,
  Illustration,
  ContactInfo,
  ContactIcon,
  ContactItem
} from './contactBanner.style';

const Banner = () => {
  const data = useStaticQuery(graphql`
    query {
      illustration: file(
        relativePath: { eq: "image/saasMinimal2/contactBanner/contact_section.png" }
      ) {
        childImageSharp {
          gatsbyImageData(
            width: 900
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `);

  return (
    <Section id="home">
      <Container>
        <ContentWrapper>
          
          <TextContent>

          <Heading content={"Let's discuss \n Your great project" }/>

            <ContactInfo>
              <ContactItem>
                <ContactIcon>
                  <Icon icon={mail} size={24} />
                </ContactIcon>
                <div>
                  <h4>Email Address</h4>
                  <p>
                    <a href="mailto:info@onlinesquad.in">info@onlinesquad.in</a>
                  </p>
                </div>
              </ContactItem>
              <ContactItem>
                <ContactIcon>
                  <Icon icon={phone} size={24} />
                </ContactIcon>
                <div>
                  <h4>Phone Numbers</h4>
                  <p>
                    <a href="tel:+919995653661">+91-999-565-3661</a>
                  </p>
                </div>
              </ContactItem>
            </ContactInfo>

          </TextContent>
          <Illustration>
            <GatsbyImage
              src={
                (data.illustration !== null) | undefined
                  ? data.illustration.childImageSharp.gatsbyImageData
                  : {}
              }
              alt="Illustration"
            />
          </Illustration>
        </ContentWrapper>
      </Container>

    </Section>
  );
};

export default Banner;
